import React, { useEffect, useState } from "react";
import { Timer } from "lucide-react";
import { getWeeklyResetCountdown, WEEKLY_RESET_TZ } from "./leaderboardHelpers";

function pad(n) {
  return String(n).padStart(2, "0");
}

export default function LeaderboardResetClock() {
  const [countdown, setCountdown] = useState(() => getWeeklyResetCountdown());

  useEffect(() => {
    const id = setInterval(() => setCountdown(getWeeklyResetCountdown()), 1000);
    return () => clearInterval(id);
  }, []);

  const { days, hours, minutes, seconds, progress } = countdown;
  const radius = 42;
  const circumference = 2 * Math.PI * radius;
  const dash = (progress / 100) * circumference;

  return (
    <section className="alb-clock" aria-label="Weekly reset countdown">
      <div className="alb-clock-ring-wrap">
        <svg className="alb-clock-ring" viewBox="0 0 100 100" aria-hidden>
          <circle cx="50" cy="50" r={radius} className="alb-clock-ring-track" />
          <circle
            cx="50"
            cy="50"
            r={radius}
            className="alb-clock-ring-progress"
            strokeDasharray={`${dash} ${circumference}`}
          />
        </svg>
        <div className="alb-clock-ring-core">
          <Timer size={16} aria-hidden />
          <strong>{days}d</strong>
        </div>
      </div>

      <div className="alb-clock-copy">
        <span className="alb-clock-eyebrow">Weekly reset</span>
        <strong className="alb-clock-title">Race to Sunday</strong>
        <div className="alb-clock-grid" aria-live="polite">
          <span><em>{pad(days)}</em><small>days</small></span>
          <span><em>{pad(hours)}</em><small>hrs</small></span>
          <span><em>{pad(minutes)}</em><small>min</small></span>
          <span><em>{pad(seconds)}</em><small>sec</small></span>
        </div>
        <p className="alb-clock-meta">{WEEKLY_RESET_TZ} · Sun 00:05</p>
      </div>
    </section>
  );
}
